import { Banknote, BarChart3, CarFront, HandCoins, LayoutDashboard, PenLine, Route, Ticket, Undo2, UserCog, Users } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export interface NavItem {
  to: string
  label: string
  icon: LucideIcon
  description: string
  /** Only highlights on an exact match — used for the overview at "/". */
  exact?: boolean
}

/**
 * The whole application in one list.
 *
 * The legacy dashboard had seven tiles, three of which were near-identical trip
 * tables ("Modify Trip Driver", "Change Trip Time", "Start & End Trip"). Those
 * are one Trips screen here; the operations they offered live on the record they
 * act on.
 */
export const NAV_ITEMS: NavItem[] = [
  {
    to: '/',
    label: 'Overview',
    icon: LayoutDashboard,
    description: 'Live operational summary',
    exact: true,
  },
  {
    to: '/reporting',
    label: 'Reporting',
    icon: BarChart3,
    description: 'Outcomes, trends and revenue',
  },
  {
    to: '/trip-requests',
    label: 'Trip requests',
    icon: Route,
    description: 'Approve, assign and reject',
  },
  {
    to: '/trip-edits',
    label: 'Trip changes',
    icon: PenLine,
    description: 'Customer edits to approve',
  },
  {
    to: '/trips',
    label: 'Trips',
    icon: CarFront,
    description: 'Dispatch and lifecycle',
  },
  {
    to: '/drivers',
    label: 'Drivers',
    icon: UserCog,
    description: 'Fleet accounts',
  },
  {
    to: '/users',
    label: 'Users',
    icon: Users,
    description: 'Passenger accounts',
  },
  {
    to: '/promo-codes',
    label: 'Promo codes',
    icon: Ticket,
    description: 'Campaigns and discounts',
  },
  {
    to: '/refunds',
    label: 'Refunds',
    icon: Undo2,
    description: 'Paymob refund ledger',
  },
  {
    to: '/penalties',
    label: 'Penalties',
    icon: HandCoins,
    description: 'Cancellation charges owed',
  },
  {
    to: '/instapay',
    label: 'Instapay account',
    icon: Banknote,
    description: 'Bank details shown to customers',
  },
]
